import { Component, Input, EventEmitter, Output } from '@angular/core';
import { FilterParameter } from '../../../filter/filter-parameter.model';

@Component({
    selector: 'ifc-filters-active-list',
    templateUrl: './filters-active-list.component.html',
    styleUrls: ['./filters-active-list.component.scss'],
    standalone: false
})
export class FiltersActiveListComponent  {
  private _filters: FilterParameter[];

  @Input()
  set filters(filters: FilterParameter[]) {
    if (!filters) return;

    this._filters = filters;
  }

  get filters(): FilterParameter[] {
    return this._filters;
  }

  @Output()
  filterRemoved = new EventEmitter<FilterParameter[]>();

  remove(filter: FilterParameter): void {
    const removed: FilterParameter[] = [];
    removed.push(filter);
    this.filterRemoved.emit(removed);
  }

  clear(): void {
    this.filterRemoved.emit(this.filters);
  }
}
